import { defineStore } from "pinia";
import { ref } from "vue";
import { TagItem } from "@/types/tags";
import { fetchTags } from "@/api/tags";

export const useBlogTagsStore = defineStore("blogTagsStore", () => {
  const blogTags = ref<TagItem[]>([]);
  const allBlogsTag = ref<TagItem>();
  const selectedBlogTagId = ref<number>();
  const isLoaded = ref(false);

  async function loadBlogTags(): Promise<void> {
    if (isLoaded.value) return;

    try {
      const res = await fetchTags();

      allBlogsTag.value = {
        id: -1,
        translations: { ru: "Все статьи", en: "All Articles" },
        blogsCount: res.totalBlogsCount,
      };
      blogTags.value = [allBlogsTag.value, ...res.tags];
      selectedBlogTagId.value = allBlogsTag.value.id;
      isLoaded.value = true;
    } catch (error) {
      console.error(error);
      isLoaded.value = false;
    }
  }

  function selectTag(tagId: number) {
    selectedBlogTagId.value = tagId;
  }

  function resetSelectedTag() {
    selectedBlogTagId.value = allBlogsTag.value?.id;
  }

  return {
    blogTags,
    selectedBlogTagId,
    selectTag,
    isLoaded,
    loadBlogTags,
    resetSelectedTag,
  };
});
